export default __webpack_public_path__ + "0b235a3b2bce24ced78596081d87e999.svg";